import polyline from 'utils/polyline';

function decodePath(str, precision) {
  const coordinates = polyline.decode(str, precision);
  return coordinates.map(coord => ({ lat: coord[0], lng: coord[1] }));
}

export default decodePath;
